import React from "react";
import ContainerComponent from "../../../components/Container/ContainerComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";

const CatalogoPromocoesPage = () => {
    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: "center",
            pt: 2
            //mt: -6
        }}
    >
        <TypographyComponent
            variant="h1"
            sx={{
                fontFamily: '"Font 2", sans-serif',
                fontWeight: 700,
                fontSize: '30px',
                lineHeight: '36px',
                letterSpacing: '0%',
                color: '#101828',
                display: 'flex',
                alignItems: 'center',
                opacity: 1,
            }}
        >
            Promoções Especiais
        </TypographyComponent>
    </ContainerComponent>
}

export default CatalogoPromocoesPage;